import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { Link } from 'react-router-dom';
import client from 'utils/client';
import TextInput from 'components/FormElements/TextInput';
import './login.css';

const initialValues = { email: '' };

// Never branch on the outcome: the API answers identically whether or not GTI holds
// the address, so success, failure and a dead network all show the same confirmation.
function RequestLink() {
  const [submittedEmail, setSubmittedEmail] = useState(null);

  const handleSubmit = (values) => {
    const email = values.email.trim();
    return client
      .post('/authentication/portal-access-request', { email })
      .finally(() => setSubmittedEmail(email));
  };

  return (
    <div className='auth-shell'>
      <div className='auth-card'>
        <div className='auth-brand'>
          <span className='auth-brand-mark' aria-hidden='true'>GTI</span>
          <span className='auth-brand-word'>Microfinance</span>
        </div>

        <div aria-live='polite'>
          {submittedEmail === null ? (
            <>
              <h1 className='auth-title'>Trouble signing in?</h1>
              <p className='auth-subtitle'>Enter your email address and we will send you a link to set your password.</p>

              <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                {({ isSubmitting }) => (
                  <Form className='auth-form'>
                    <TextInput className='form-field' name='email' type='email' label='Email' placeholder='you@example.com' autoComplete='email' autoFocus required />
                    <button type='submit' className='btn-primary auth-submit' disabled={isSubmitting}>
                      {isSubmitting ? 'Sending…' : 'Send me a link'}
                    </button>
                  </Form>
                )}
              </Formik>
            </>
          ) : (
            <>
              <h1 className='auth-title'>Check your email</h1>
              <p className='auth-subtitle'>If GTI has an account for that address, a link is on its way.</p>
              <p className='auth-confirm-email'>{submittedEmail}</p>
              <p className='auth-confirm-text'>Still nothing after a few minutes? Check your spam folder, or call your GTI relationship officer.</p>
            </>
          )}
        </div>

        <p className='auth-footer'>
          <Link className='auth-link' to='/'>Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}

export default RequestLink;
